import logo from './imgs/icons/logo.svg'
import fbIcon from './imgs/icons/fb-icon.svg'
import igIcon from './imgs/icons/ig-icon.svg'
import inIcon from './imgs/icons/in-icon.svg'
import frIcon from './imgs/icons/fr-icon.png'
import engIcon from './imgs/icons/eng-icon.png'
import heroimg from './imgs/main/heroimg.svg'
import heroimg2 from './imgs/main/heroimg-2.jpg'
import catalogue from './imgs/main/catalogue.png'
import norme1 from './imgs/normes/IMO.svg'
import norme2 from './imgs/normes/ISO.svg'
import norme3 from './imgs/normes/ISO3864.svg'
import norme4 from './imgs/normes/ISO7010.svg'
import norme5 from './imgs/normes/ISO16069.svg'
import norme6 from './imgs/normes/ISO17398.svg'
import norme7 from './imgs/normes/ISO20560.svg'
import norme8 from './imgs/normes/ISO23601.svg'
import norme9 from './imgs/normes/ANSI.svg'
import norme10 from './imgs/normes/DOTUSA.svg'
import norme11 from './imgs/normes/ICC.svg'
import norme12 from './imgs/normes/OSHA.svg'
import norme13 from './imgs/normes/NFPA.svg'
import norme14 from './imgs/normes/ADR.svg'
import norme15 from './imgs/normes/GHS.svg'
import norme16 from './imgs/normes/ADA.svg'
import product1 from './imgs/products/sign-ISO.svg'
import product2 from './imgs/products/OSHA-ANSI.svg'
import product3 from './imgs/products/sign-D.svg'
import product4 from './imgs/products/GHS-CLP.svg'
import product5 from './imgs/products/sign-CI.svg'
import product6 from './imgs/products/Covid.svg'
import product7 from './imgs/products/EI.svg'
import product8 from './imgs/products/ARD-IMDG.svg'
import product9 from './imgs/products/evacuation.jpg'
import lami_logo from './imgs/LAMI/LAMI-Guard-Logo.svg'
import lami_main from './imgs/LAMI/LAMI-main-img.svg'
import lami_icon1 from './imgs/LAMI/icon1.svg'
import lami_icon2 from './imgs/LAMI/icon2.svg'
import lami_icon3 from './imgs/LAMI/icon3.svg'
import lami_icon4 from './imgs/LAMI/icon4.svg'
import service1 from './imgs/services/DG-1.jpg'
import service2 from './imgs/services/DG-2.jpg'
import service3 from './imgs/services/DG-3.jpg'
import service4 from './imgs/services/PR-1.png'
import service5 from './imgs/services/PR-2.jpg'
import service6 from './imgs/services/PR-3.jpg'
import partner1 from './imgs/partners/part1.png'
import partner2 from './imgs/partners/part2.png'
import partner3 from './imgs/partners/part3.png'
import partner4 from './imgs/partners/part4.png'
import partner5 from './imgs/partners/part5.png'
import partner6 from './imgs/partners/part6.jpg'
import brochure1 from './imgs/cat/agro.png'
import brochure2 from './imgs/cat/const.png'
import brochure3 from './imgs/cat/covid.png'
import brochure4 from './imgs/cat/med.png'
import brochure5 from './imgs/cat/petro.png'
import brochure6 from './imgs/cat/pub.png'
const NavData = {
  logo,
  fbIcon,
  igIcon,
  inIcon,
  frIcon,
  engIcon,
  links: ['/', 'devis', 'contact'],
  fr: ['Accueil', 'Demande de devis', 'Contact'],
  en: ['Home', 'Request a quote', 'Contact'],
}
const MainData = {
  fr: {
    s1: {
      title: 'Une signalisation pour chaque danger',
      desc: 'Avec notre large gamme de produits ABS Safety nous couvrons tous les risques et dangers que vous pouvez rencontrer sur votre site de travail.',
      btn: 'Télécharger nos brochures',
      img: heroimg
    },
    off_s1: {
      title: 'Nous suivons les normes internationales',
      imgs: [
        norme1,
        norme2,
        norme3,
        norme4,
        norme5,
        norme6,
        norme7,
        norme8,
        norme9,
        norme10,
        norme11,
        norme12,
        norme13,
        norme14,
        norme15,
        norme16
      ]
    },
    s2: {
      title: 'Qui sommes nous?',
      desc: "Tout ce que nous faisons concerne votre sécurité, de la haute direction qui crée des stratégies à l'équipe de techniciens qui sait exactement comment garder votre ligne de sécurité prête. Créée en 2017 par des experts afin de fournir d’excellentes solutions de sécurité pour les industries pétrolières et gazières, de la solution de détection et de protection des gaz aux solutions de signalisation de sécurité complètes en 2021, nous passons tout notre temps à améliorer nos produits et services afin d'offrir aux travailleurs Les meilleures solutions de sécurité.",
      img: heroimg2
    },
    s3: {
      title: 'Nos produits',
      cards: [
        {
          title: 'Signalisation ISO 7010',
          img: product1,
          desc: 'ABS SAFETY vous propose tous les panneaux de sécurité ISO 7010 sur des matériaux de hautes performances pour une durabilité optimale.'
        },
        {
          title: 'OSHA/ANSI',
          img: product2,
          desc: 'Une grande variété de signalisation selon les normes ANSI Z535 et OSHA dans une variété de tailles et de matériaux.'
        },
        {
          title: 'Signalisation par Danger',
          img: product3,
          desc: "ABS SAFETY vous propose une large et diverse gamme de panneaux combinés classés par risque."
        },
        {
          title: 'GHS-CLP',
          img: product4,
          desc: 'Des panneaux et des étiquettes conformes à la norme GHS/CLP pour la classification et l’ettiquetage des produits chimiques.'
        },
        {
          title: 'Circulation interne',
          img: product5,
          desc: "Des panneaux indiquant les règles de circulation, les dangers de la route et l'emplacement."
        },
        {
          title: 'COVID 19',
          img: product6,
          desc: 'Signalisation liées à la pandémie dans une variété de formats et des matériaux.'
        },
        {
          title: 'Etiquettes d’inspection',
          img: product7,
          desc: 'Étiquettes ANSI Z535 et OSHA dans une variété de tailles et des matériaux.'
        },
        {
          title: 'ARD-IMDG',
          img: product8,
          desc: "ABS SAFETY vous propose l'ensemble des panneaux ADR pour l'identification des véhicules transportant des produits chimiques et dangereux."
        },
        {
          title: "Plan d'evacuation",
          img: product9,
          desc: 'Un plan d’évacuation est un plan qui doit être impérativement être placé à chaque niveau du bâtiment pour faciliter l’évacuation des personnes présentes dans le bâtiment en cas d’incendie. Nous vous proposons des plans personnalisés à vos immeubles dans tous les formats, sur tous les supports et en pleine conformité avec les normes en vigueur.'
        }
      ]
    },
    s4: {
      desc: 'Notre NOUVELLE formule améliorée LAMIGuard® donne une protection à vos signalisations assez puissante pour survivre dans la plupart des environnements.',
      img: lami_main,
      logo: lami_logo,
      detail_1: 'LAMI Guard une protection contre les UV, les liquides, les produits chimiques et les intempéries.',
      detail_2: 'Vinyle de qualité supérieure imprimé avec une encre de protection UV pour assurer des couleurs éclatantes et durables.',
      cards: [
        {
          img: lami_icon1,
          title: "Résistant à l'abrasion."
        },
        {
          img: lami_icon2,
          title: 'Résistant aux Produits Chimiques'
        },
        {
          img: lami_icon4,
          title: 'Résistant à l’eau'
        },
        {
          img: lami_icon3,
          title: 'Protection contre UV et la perte des couleurs'
        },
      ]
    },
    s5: [
      {
        title: 'Detection de gaz',
        cards: [
          {
            title: 'Vente',
            desc: 'Vous cherchez à acquérir une nouvelle solution de détection? Ou pour remplacer ce que vous avez déjà ? Nous sommes là pour vous aider. Que vous sachiez exactement vos besoin ou que vous cherchiez encore, nous pouvons vous faire une offre qui répondra à vos besoins.',
            img: service1
          },
          {
            title: 'Location',
            desc: "Si vous avez besoin d'une solution de détection de gaz pour une période limitée, vous pouvez louer une solution prête à l’utilisation sans vous soucier de la maintenance.",
            img: service2
          },
          {
            title: 'Calibrage & Servicing',
            desc: "Nous disposons des personnes, des programmes et des procédés pour vous fournir les meilleurs délais et services, nous pouvons entretenir votre flotte existante, quelle que soit la marque ou l'endroit où vous l'avez achetée.",
            img: service3
          },
        ]
      },
      {
        title: 'Protection resporatoire',
        cards: [
          {
            title: 'Vente | Location',
            desc: "ABS Safety fournit un équipement de la meilleure qualité et l'assistance sans précédent pour protéger vos employés et préserver la rentabilité de votre activité ARI (SCBA) de 60, 30 ou 15 min Escape Set d’urgence. Conçu pour une utilisation",
            img: service5
          },
          {
            title: 'Fit-test',
            desc: 'Pour offrir la protection attendue, les dispositifs respiratoires étanches doivent bien adhérer au visage de l’utilisateur. Pour plus d’information contactez-nous.',
            img: service4
          },
          {
            title: 'Inspection',
            desc: "L’appareil respiratoire isolant (ARI) exige un entretien régulier à des intervalles spécifiques pour que votre équipement de sauvetage puisse fonctionner dans les conditions les plus difficiles. Nos techniciens sont formés et sont habilités à réparer les équipements d'air respirable. Une maintenance préventive appropriée peut contribuer dans une large mesure à garantir que votre équipement continue de fonctionner à son niveau optimal. Hydro-Test : des essais hydrostatiques de cylindres en acier, aluminium et fibres de carbone doivent être effectués tous les cinq ans (5) ou trois ans (3) pour les cylindres en fibre de verre. Inspection des fonctions : Tous les ARI à circuit ouvert nécessitent des tests de débit et des inspections visuelles internes de bouteilles d’air respirable doivent être effectués anuellement. Remplissage: Une qualité d’air de remplissage de vos cylindres conforme à la réglementation CSA Z180.1-13 200 Bar/ 300 Bar",
            img: service6
          },
        ]
      },
    ],
    off_s2: {
      title: 'ils nous font confiance',
      imgs: [
        partner1,
        partner2,
        partner3,
        partner4,
        partner5,
        partner6
      ]
    },
    s6: {
      title: 'Demande de notre catalogue',
      desc: 'Un catalogue avec plus de 35 000 produits de signalisation, ABS SAFETY vous offre une solution de signalisation étudiée et adaptée à chaque danger et risque dans votre site de travail.',
      btn: 'Demande un devis',
      img: catalogue
    }
  },
  en: {
    s1: {
      title: 'Signage for every danger',
      desc: 'With our wide range of ABS Safety products we cover all the risks and dangers that you may encounter on your work site.',
      btn: 'Download our brochures',
      img: heroimg
    },
    off_s1: {
      title: 'Nous suivons les normes internationales',
      imgs: [
        norme1,
        norme2,
        norme3,
        norme4,
        norme5,
        norme6,
        norme7,
        norme8,
        norme9,
        norme10,
        norme11,
        norme12,
        norme13,
        norme14,
        norme15,
        norme16
      ]
    },
    s2: {
      title: 'Who are we?',
      desc: "Everything we do is about your safety, from senior management creating strategies, to the team of technicians who know exactly how to keep your safety line ready. Established in 2017 by experts to provide excellent safety solutions for the oil and gas industries, from gas detection and protection solution to comprehensive safety signage solutions in 2021, we spend all of our time improving our products and services to provide workers with the best safety solutions.",
      img: heroimg2
    },
    s3: {
      title: 'Our products',
      cards: [
        {
          title: 'ISO 7010 signage',
          img: product1,
          desc: 'ABS SAFETY offers you all ISO 7010 safety panels on high performance materials for optimal durability.'
        },
        {
          title: 'OSHA/ANSI',
          img: product2,
          desc: 'A wide variety of signage according to ANSI Z535 and OSHA standards in a variety of sizes and materials.'
        },
        {
          title: 'Signage by Danger',
          img: product3,
          desc: "ABS SAFETY offers you a wide and diverse range of combination panels classified by risk."
        },
        {
          title: 'GHS-CLP',
          img: product4,
          desc: 'Signs and labels conforming to the GHS / CLP standard for the classification and labeling of chemicals.'
        },
        {
          title: 'Internal circulation',
          img: product5,
          desc: "Signs indicating traffic rules, road hazards and location."
        },
        {
          title: 'COVID 19',
          img: product6,
          desc: 'Signage related to the pandemic in a variety of formats and materials.'
        },
        {
          title: 'Inspection labels',
          img: product7,
          desc: 'ANSI Z535 and OSHA labels in a variety of sizes and materials.'
        },
        {
          title: 'ARD-IMDG',
          img: product8,
          desc: "ABS SAFETY offers you all the ADR panels for the identification of vehicles transporting chemical and dangerous products."
        },
        {
          title: "Evacuation plan",
          img: product9,
          desc: 'An evacuation plan is a plan that must be placed at each level of the building to facilitate the evacuation of people in the building in the event of a fire. We offer personalized plans for your buildings in all formats, on all media and in full compliance with the standards in force.'
        }
      ]
    },
    s4: {
      desc: 'Our NEW and improved LAMIGuard® formula gives your signage protection powerful enough to survive in most environments.',
      img: lami_main,
      logo: lami_logo,
      detail_1: 'LAMI Guard provides protection against UV rays, liquids, chemicals and weathering.',
      detail_2: 'Premium vinyl printed with UV protective ink to ensure vibrant, long-lasting colors.',
      cards: [
        {
          img: lami_icon1,
          title: "Abrasion resistant"
        },
        {
          img: lami_icon2,
          title: 'Chemical Resistant'
        },
        {
          img: lami_icon4,
          title: 'Waterproof'
        },
        {
          img: lami_icon3,
          title: 'UV protection and color loss'
        },
      ]
    },
    s5: [
      {
        title: 'Gas detection',
        cards: [
          {
            title: 'Sale',
            desc: 'Are you looking to acquire a new detection solution? Or to replace what you already have? We are here to help you. Whether you know your exact needs or are still looking, we can make you an offer that will meet your needs.',
            img: service1
          },
          {
            title: 'Location',
            desc: "If you need a gas detection solution for a limited period of time, you can rent a ready-to-use solution without worrying about maintenance.",
            img: service2
          },
          {
            title: 'Calibration & Servicing',
            desc: "We have the people, programs and processes to provide you with the fastest time and service, we can service your existing fleet, no matter what brand or where you purchased it.",
            img: service3
          },
        ]
      },
      {
        title: 'Respiratory protection',
        cards: [
          {
            title: 'Sale | Rental',
            desc: "ABS Safety provides the best quality equipment and unprecedented support to protect your employees and keep your 60, 30 or 15 minute Emergency Escape Set SCBA business profitable. Designed for use",
            img: service5
          },
          {
            title: 'Fit-test',
            desc: "To provide the expected protection, airtight breathing apparatus must adhere well to the user's face. For more information, contact us.",
            img: service4
          },
          {
            title: 'Inspection',
            desc: "Self-Contained Breathing Apparatus (SCBA) requires regular maintenance at specific intervals so that your rescue equipment can operate under the most difficult conditions. Our technicians are trained and authorized to repair breathing air equipment. Proper preventive maintenance can go a long way in ensuring that your equipment continues to perform at its optimum level. Hydro-Test: Hydrostatic tests of steel, aluminum and carbon fiber cylinders must be performed every five (5) or three (3) years for fiberglass cylinders. Function Inspection: All open circuit SCBAs require flow testing and internal visual inspections of breathing air cylinders should be performed annually. Filling: A quality of air for filling your cylinders in accordance with CSA Z180.1-13 200 Bar / 300 Bar",
            img: service6
          },
        ]
      },
    ],
    off_s2: {
      title: 'They trust us',
      imgs: [
        partner1,
        partner2,
        partner3,
        partner4,
        partner5,
        partner6
      ]
    },
    s6: {
      title: 'Request our catalog',
      desc: 'A catalog with more than 35,000 signaling products, ABS SAFETY offers you a signaling solution studied and adapted to each danger and risk in your work site.',
      btn: 'Request a quote',
      img: catalogue
    }
  }
}

const brochureRequestData = {
  fr: {
    title: 'Demande de catalogue',
    tab1: 'Nom et prénom',
    tab2: 'Email',
    tab3: 'Numéro',
    tab4: 'Entreprise',
    tab5: 'Site-web (optionnel)',
    tab6: 'Remarque',
    btn: 'Télécharger',
    options: [
      {
        title: 'Industries Agro-Alimentaire',
        img: brochure1
      },
      {
        title: 'Les Sites de Construction',
        img: brochure2
      },
      {
        title: 'Covid-19',
        img: brochure3
      },
      {
        title: 'Medical',
        img: brochure4
      },
      {
        title: 'Industries Petrolier',
        img: brochure5
      },
      {
        title: 'Espaces Public Administrations',
        img: brochure6
      },
    ]
  },
  en: {
    title: 'Catalog request',
    tab1: 'Name & Surname',
    tab2: 'Email',
    tab3: 'Number',
    tab4: 'Company',
    tab5: 'Web site (optionnal)',
    btn: 'Download',
    options: [
      {
        title: 'Agri-Food Industries',
        img: brochure1
      },
      {
        title: 'Construction sites',
        img: brochure2
      },
      {
        title: 'Covid-19',
        img: brochure3
      },
      {
        title: 'Medical',
        img: brochure4
      },
      {
        title: 'Petroleum Industries',
        img: brochure5
      },
      {
        title: 'Public spaces Administrations',
        img: brochure6
      },
    ]
  }
}

const QuoteData = {
  fr: {
    title: 'Demande de devis',
    desc: "Si vous avez besoin d'un devis sur des références personnalisées ou sur un produit particulier, complétez le formulaire ci-dessous, nous prenons contact avec vous dans les meilleurs délais pour vous apporter une réponse.",
    tab1: 'Nom et prénom',
    tab2: 'Email',
    tab3: 'Adresse',
    tab4: [
      { code: "+213", country: "Algérie" },
      { code: "+7 840", country: "Abkhazie" },
      { code: "+93", country: "Afghanistan" },
      { code: "+27", country: "Afrique du Sud" },
      { code: "+355", country: "Albanie" },
      { code: "+49", country: "Allemagne" },
      { code: "+376", country: "Andorre" },
      { code: "+244", country: "Angola" },
      { code: "+1 264", country: "Anguilla" },
      { code: "+1 268", country: "Antigua-et-Barbuda" },
      { code: "+596", country: "Antilles françaises" },
      { code: "+599", country: "Antilles néerlandaises" },
      { code: "+966", country: "Arabie saoudite" },
      { code: "+54", country: "Argentine" },
      { code: "+374", country: "Arménie" },
      { code: "+297", country: "Aruba" },
      { code: "+247", country: "Ascension" },
      { code: "+61", country: "Australie" },
      { code: "+43", country: "Autriche" },
      { code: "+994", country: "Azerbaïdjan" },
      { code: "+1 242", country: "Bahamas" },
      { code: "+973", country: "Bahreïn" },
      { code: "+880", country: "Bangladesh" },
      { code: "+1 246", country: "Barbade" },
      { code: "+1 268", country: "Barbuda" },
      { code: "+32", country: "Belgique" },
      { code: "+501", country: "Belize" },
      { code: "+229", country: "Bénin" },
      { code: "+1 441", country: "Bermudes" },
      { code: "+975", country: "Bhoutan" },
      { code: "+375", country: "Biélorussie" },
      { code: "+591", country: "Bolivie" },
      { code: "+387", country: "Bosnie-Herzégovine" },
      { code: "+267", country: "Botswana" },
      { code: "+55", country: "Brésil" },
      { code: "+673", country: "Brunéi" },
      { code: "+359", country: "Bulgarie" },
      { code: "+226", country: "Burkina Faso" },
      { code: "+257", country: "Burundi" },
      { code: "+855", country: "Cambodge" },
      { code: "+237", country: "Cameroun" },
      { code: "+1", country: "Canada" },
      { code: "+238", country: "Cap-Vert" },
      { code: "+56", country: "Chili" },
      { code: "+86", country: "Chine" },
      { code: "+537", country: "Chypre" },
      { code: "+57", country: "Colombie" },
      { code: "+269", country: "Comores" },
      { code: "+242", country: "Congo" },
      { code: "+243", country: "Congo, Rép. Dém. du (Zaïre)" },
      { code: "+850", country: "Corée du Nord" },
      { code: "+82", country: "Corée du Sud" },
      { code: "+506", country: "Costa Rica" },
      { code: "+225", country: "Côte d'Ivoire" },
      { code: "+385", country: "Croatie" },
      { code: "+53", country: "Cuba" },
      { code: "+599", country: "Curaçao" },
      { code: "+45", country: "Danemark" },
      { code: "+246", country: "Diego Garcia" },
      { code: "+253", country: "Djibouti" },
      { code: "+1 767", country: "Dominique" },
      { code: "+20", country: "Egypte" },
      { code: "+971", country: "Emirats Arabes Unis" },
      { code: "+593", country: "Equateur" },
      { code: "+291", country: "Erythrée" },
      { code: "+34", country: "Espagne" },
      { code: "+372", country: "Estonie" },
      { code: "+1", country: "États-Unis" },
      { code: "+251", country: "Éthiopie" },
      { code: "+679", country: "Fidji" },
      { code: "+358", country: "Finlande" },
      { code: "+33", country: "France" },
      { code: "+241", country: "Gabon" },
      { code: "+220", country: "Gambie" },
      { code: "+995", country: "Géorgie" },
      { code: "+500", country: "Géorgie du Sud et les îles Sandwich du Sud" },
      { code: "+233", country: "Ghana" },
      { code: "+350", country: "Gibraltar" },
      { code: "+30", country: "Grèce" },
      { code: "+1 473", country: "Grenade" },
      { code: "+299", country: "Groenland" },
      { code: "+590", country: "Guadeloupe" },
      { code: "+1 671", country: "Guam" },
      { code: "+502", country: "Guatemala" },
      { code: "+224", country: "Guinée" },
      { code: "+240", country: "Guinée équatoriale" },
      { code: "+245", country: "Guinée-Bissau" },
      { code: "+595", country: "Guyane" },
      { code: "+594", country: "Guyane française" },
      { code: "+509", country: "Haïti" },
      { code: "+504", country: "Honduras" },
      { code: "+852", country: "Hong Kong RAS Chine" },
      { code: "+36", country: "Hongrie" },
      { code: "+61", country: "Île de Noël" },
      { code: "+56", country: "Île de Pâques" },
      { code: "+672", country: "Île Norfolk" },
      { code: "+ 345", country: "Îles Caïmans" },
      { code: "+61", country: "Îles Cocos-Keeling" },
      { code: "+682", country: "Îles Cook" },
      { code: "+298", country: "Îles Féroé" },
      { code: "+500", country: "Îles Malouines" },
      { code: "+1 670", country: "Îles Mariannes du Nord" },
      { code: "+692", country: "Îles Marshall" },
      { code: "+677", country: "Îles Salomon" },
      { code: "+1 649", country: "Îles Turques et Caïques" },
      { code: "+1 340", country: "Îles Vierges américaines" },
      { code: "+1 284", country: "Îles Vierges britanniques" },
      { code: "+91", country: "Inde" },
      { code: "+62", country: "Indonésie" },
      { code: "+964", country: "Irak" },
      { code: "+98", country: "Iran" },
      { code: "+353", country: "Irlande" },
      { code: "+354", country: "Islande" },
      { code: "+972", country: "Israël" },
      { code: "+39", country: "Italie" },
      { code: "+1 876", country: "Jamaïque" },
      { code: "+81", country: "Japon" },
      { code: "+962", country: "Jordanie" },
      { code: "+7 7", country: "Kazakhstan" },
      { code: "+254", country: "Kenya" },
      { code: "+996", country: "Kirghizistan" },
      { code: "+686", country: "Kiribati" },
      { code: "+965", country: "Koweït" },
      { code: "+1 808", country: "L'île de Midway" },
      { code: "+856", country: "Laos" },
      { code: "+266", country: "Lesotho" },
      { code: "+371", country: "Lettonie" },
      { code: "+961", country: "Liban" },
      { code: "+231", country: "Libéria" },
      { code: "+218", country: "Libye" },
      { code: "+423", country: "Liechtenstein" },
      { code: "+370", country: "Lituanie" },
      { code: "+352", country: "Luxembourg" },
      { code: "+853", country: "Macao RAS Chine" },
      { code: "+389", country: "Macédoine" },
      { code: "+261", country: "Madagascar" },
      { code: "+60", country: "Malaisie" },
      { code: "+265", country: "Malawi" },
      { code: "+960", country: "Maldives" },
      { code: "+223", country: "Mali" },
      { code: "+356", country: "Malte" },
      { code: "+212", country: "Maroc" },
      { code: "+596", country: "Martinique" },
      { code: "+230", country: "Maurice" },
      { code: "+222", country: "Mauritanie" },
      { code: "+262", country: "Mayotte" },
      { code: "+52", country: "Mexique" },
      { code: "+691", country: "Micronésie" },
      { code: "+373", country: "Moldavie" },
      { code: "+377", country: "Monaco" },
      { code: "+976", country: "Mongolie" },
      { code: "+382", country: "Monténégro" },
      { code: "+1664", country: "Montserrat" },
      { code: "+95", country: "Myanmar" },
      { code: "+264", country: "Namibie" },
      { code: "+674", country: "Nauru" },
      { code: "+977", country: "Népal" },
      { code: "+1 869", country: "Nevis" },
      { code: "+505", country: "Nicaragua" },
      { code: "+227", country: "Niger" },
      { code: "+234", country: "Nigéria" },
      { code: "+47", country: "Norvège" },
      { code: "+683", country: "Noué" },
      { code: "+687", country: "Nouvelle-Calédonie" },
      { code: "+64", country: "Nouvelle-Zélande" },
      { code: "+968", country: "Oman" },
      { code: "+256", country: "Ouganda" },
      { code: "+998", country: "Ouzbékistan" },
      { code: "+92", country: "Pakistan" },
      { code: "+680", country: "Palaos" },
      { code: "+507", country: "Panama" },
      { code: "+675", country: "Papouasie-Nouvelle-Guinée" },
      { code: "+595", country: "Paraguay" },
      { code: "+31", country: "Pays-Bas" },
      { code: "+51", country: "Pérou" },
      { code: "+63", country: "Philippines" },
      { code: "+48", country: "Pologne" },
      { code: "+689", country: "Polynésie française" },
      { code: "+1 787", country: "Porto Rico" },
      { code: "+351", country: "Portugal" },
      { code: "+974", country: "Qatar" },
      { code: "+236", country: "République centrafricaine" },
      { code: "+1 809", country: "République dominicaine" },
      { code: "+420", country: "République tchèque" },
      { code: "+262", country: "Réunion" },
      { code: "+40", country: "Roumanie" },
      { code: "+44", country: "Royaume-Uni" },
      { code: "+7", country: "Russie" },
      { code: "+250", country: "Rwanda" },
      { code: "+378", country: "Saint-Marin" },
      { code: "+503", country: "Salvador" },
      { code: "+685", country: "Samoa" },
      { code: "+1 684", country: "Samoa américaines" },
      { code: "+221", country: "Sénégal" },
      { code: "+381", country: "Serbie" },
      { code: "+248", country: "Seychelles" },
      { code: "+232", country: "Sierra Leone" },
      { code: "+65", country: "Singapour" },
      { code: "+421", country: "Slovaquie" },
      { code: "+386", country: "Slovénie" },
      { code: "+249", country: "Soudan" },
      { code: "+94", country: "Sri Lanka" },
      { code: "+46", country: "Suède" },
      { code: "+41", country: "Suisse" },
      { code: "+597", country: "Suriname" },
      { code: "+268", country: "Swaziland" },
      { code: "+963", country: "Syrie" },
      { code: "+992", country: "Tadjikistan" },
      { code: "+886", country: "Taïwan" },
      { code: "+255", country: "Tanzanie" },
      { code: "+235", country: "Tchad" },
      { code: "+246", country: "Territoire britannique de l'océan Indien" },
      { code: "+970", country: "Territoire palestinien" },
      { code: "+672", country: "Territoires extérieurs australiens" },
      { code: "+66", country: "Thaïlande" },
      { code: "+670", country: "Timor oriental" },
      { code: "+670", country: "Timor oriental" },
      { code: "+228", country: "Togo" },
      { code: "+690", country: "Tokélaou" },
      { code: "+676", country: "Tonga" },
      { code: "+1 868", country: "Trinité-et-Tobago" },
      { code: "+216", country: "Tunisie" },
      { code: "+993", country: "Turkménistan" },
      { code: "+90", country: "Turquie" },
      { code: "+688", country: "Tuvalu" },
      { code: "+380", country: "Ukraine" },
      { code: "+598", country: "Uruguay" },
      { code: "+678", country: "Vanuatu" },
      { code: "+58", country: "Venezuela" },
      { code: "+84", country: "Vietnam" },
      { code: "+1 808", country: "Wake Island" },
      { code: "+681", country: "Wallis et Futuna" },
      { code: "+967", country: "Yémen" },
      { code: "+260", country: "Zambie" },
      { code: "+255", country: "Zanzibar" },
      { code: "+263", country: "Zimbabwe" },
    ],
    tab5: 'Ville',
    tab6: 'Numéro',
    tab7: 'Société',
    tab8: 'Position',
    tab9: 'Veuillez préciser votre demande (optionnel)',
    btn: 'Envoyer'
  },
  en: {
    title: 'Request a quote',
    desc: "If you need a quote on personalized references or on a particular product, complete the form below, we will contact you as soon as possible to provide you with an answer.",
    tab1: 'Name & Surname',
    tab2: 'Email',
    tab3: 'Address',
    tab4: [
      {
        code: "+213",
        country: "Algeria"
      },
      {
        code: "+7 840",
        country: "Abkhazia"
      },
      {
        code: "+93",
        country: "Afghanistan"
      },
      {
        code: "+355",
        country: "Albania"
      },
      {
        code: "+1 684",
        country: "American Samoa"
      },
      {
        code: "+376",
        country: "Andorra"
      },
      {
        code: "+244",
        country: "Angola"
      },
      {
        code: "+1 264",
        country: "Anguilla"
      },
      {
        code: "+1 268",
        country: "Antigua and Barbuda"
      },
      {
        code: "+54",
        country: "Argentina"
      },
      {
        code: "+374",
        country: "Armenia"
      },
      {
        code: "+297",
        country: "Aruba"
      },
      {
        code: "+247",
        country: "Ascension"
      },
      {
        code: "+61",
        country: "Australia"
      },
      {
        code: "+672",
        country: "Australian External Territories"
      },
      {
        code: "+43",
        country: "Austria"
      },
      {
        code: "+994",
        country: "Azerbaijan"
      },
      {
        code: "+1 242",
        country: "Bahamas"
      },
      {
        code: "+973",
        country: "Bahrain"
      },
      {
        code: "+880",
        country: "Bangladesh"
      },
      {
        code: "+1 246",
        country: "Barbados"
      },
      {
        code: "+1 268",
        country: "Barbuda"
      },
      {
        code: "+375",
        country: "Belarus"
      },
      {
        code: "+32",
        country: "Belgium"
      },
      {
        code: "+501",
        country: "Belize"
      },
      {
        code: "+229",
        country: "Benin"
      },
      {
        code: "+1 441",
        country: "Bermuda"
      },
      {
        code: "+975",
        country: "Bhutan"
      },
      {
        code: "+591",
        country: "Bolivia"
      },
      {
        code: "+387",
        country: "Bosnia and Herzegovina"
      },
      {
        code: "+267",
        country: "Botswana"
      },
      {
        code: "+55",
        country: "Brazil"
      },
      {
        code: "+246",
        country: "British Indian Ocean Territory"
      },
      {
        code: "+1 284",
        country: "British Virgin Islands"
      },
      {
        code: "+673",
        country: "Brunei"
      },
      {
        code: "+359",
        country: "Bulgaria"
      },
      {
        code: "+226",
        country: "Burkina Faso"
      },
      {
        code: "+257",
        country: "Burundi"
      },
      {
        code: "+855",
        country: "Cambodia"
      },
      {
        code: "+237",
        country: "Cameroon"
      },
      {
        code: "+1",
        country: "Canada"
      },
      {
        code: "+238",
        country: "Cape Verde"
      },
      {
        code: "+ 345",
        country: "Cayman Islands"
      },
      {
        code: "+236",
        country: "Central African Republic"
      },
      {
        code: "+235",
        country: "Chad"
      },
      {
        code: "+56",
        country: "Chile"
      },
      {
        code: "+86",
        country: "China"
      },
      {
        code: "+61",
        country: "Christmas Island"
      },
      {
        code: "+61",
        country: "Cocos-Keeling Islands"
      },
      {
        code: "+57",
        country: "Colombia"
      },
      {
        code: "+269",
        country: "Comoros"
      },
      {
        code: "+242",
        country: "Congo"
      },
      {
        code: "+243",
        country: "Congo, Dem. Rep. of (Zaire)"
      },
      {
        code: "+682",
        country: "Cook Islands"
      },
      {
        code: "+506",
        country: "Costa Rica"
      },
      {
        code: "+385",
        country: "Croatia"
      },
      {
        code: "+53",
        country: "Cuba"
      },
      {
        code: "+599",
        country: "Curacao"
      },
      {
        code: "+537",
        country: "Cyprus"
      },
      {
        code: "+420",
        country: "Czech Republic"
      },
      {
        code: "+45",
        country: "Denmark"
      },
      {
        code: "+246",
        country: "Diego Garcia"
      },
      {
        code: "+253",
        country: "Djibouti"
      },
      {
        code: "+1 767",
        country: "Dominica"
      },
      {
        code: "+1 809",
        country: "Dominican Republic"
      },
      {
        code: "+670",
        country: "East Timor"
      },
      {
        code: "+56",
        country: "Easter Island"
      },
      {
        code: "+593",
        country: "Ecuador"
      },
      {
        code: "+20",
        country: "Egypt"
      },
      {
        code: "+503",
        country: "El Salvador"
      },
      {
        code: "+240",
        country: "Equatorial Guinea"
      },
      {
        code: "+291",
        country: "Eritrea"
      },
      {
        code: "+372",
        country: "Estonia"
      },
      {
        code: "+251",
        country: "Ethiopia"
      },
      {
        code: "+500",
        country: "Falkland Islands"
      },
      {
        code: "+298",
        country: "Faroe Islands"
      },
      {
        code: "+679",
        country: "Fiji"
      },
      {
        code: "+358",
        country: "Finland"
      },
      {
        code: "+33",
        country: "France"
      },
      {
        code: "+596",
        country: "French Antilles"
      },
      {
        code: "+594",
        country: "French Guiana"
      },
      {
        code: "+689",
        country: "French Polynesia"
      },
      {
        code: "+241",
        country: "Gabon"
      },
      {
        code: "+220",
        country: "Gambia"
      },
      {
        code: "+995",
        country: "Georgia"
      },
      {
        code: "+49",
        country: "Germany"
      },
      {
        code: "+233",
        country: "Ghana"
      },
      {
        code: "+350",
        country: "Gibraltar"
      },
      {
        code: "+30",
        country: "Greece"
      },
      {
        code: "+299",
        country: "Greenland"
      },
      {
        code: "+1 473",
        country: "Grenada"
      },
      {
        code: "+590",
        country: "Guadeloupe"
      },
      {
        code: "+1 671",
        country: "Guam"
      },
      {
        code: "+502",
        country: "Guatemala"
      },
      {
        code: "+224",
        country: "Guinea"
      },
      {
        code: "+245",
        country: "Guinea-Bissau"
      },
      {
        code: "+595",
        country: "Guyana"
      },
      {
        code: "+509",
        country: "Haiti"
      },
      {
        code: "+504",
        country: "Honduras"
      },
      {
        code: "+852",
        country: "Hong Kong SAR China"
      },
      {
        code: "+36",
        country: "Hungary"
      },
      {
        code: "+354",
        country: "Iceland"
      },
      {
        code: "+91",
        country: "India"
      },
      {
        code: "+62",
        country: "Indonesia"
      },
      {
        code: "+98",
        country: "Iran"
      },
      {
        code: "+964",
        country: "Iraq"
      },
      {
        code: "+353",
        country: "Ireland"
      },
      {
        code: "+972",
        country: "Israel"
      },
      {
        code: "+39",
        country: "Italy"
      },
      {
        code: "+225",
        country: "Ivory Coast"
      },
      {
        code: "+1 876",
        country: "Jamaica"
      },
      {
        code: "+81",
        country: "Japan"
      },
      {
        code: "+962",
        country: "Jordan"
      },
      {
        code: "+7 7",
        country: "Kazakhstan"
      },
      {
        code: "+254",
        country: "Kenya"
      },
      {
        code: "+686",
        country: "Kiribati"
      },
      {
        code: "+965",
        country: "Kuwait"
      },
      {
        code: "+996",
        country: "Kyrgyzstan"
      },
      {
        code: "+856",
        country: "Laos"
      },
      {
        code: "+371",
        country: "Latvia"
      },
      {
        code: "+961",
        country: "Lebanon"
      },
      {
        code: "+266",
        country: "Lesotho"
      },
      {
        code: "+231",
        country: "Liberia"
      },
      {
        code: "+218",
        country: "Libya"
      },
      {
        code: "+423",
        country: "Liechtenstein"
      },
      {
        code: "+370",
        country: "Lithuania"
      },
      {
        code: "+352",
        country: "Luxembourg"
      },
      {
        code: "+853",
        country: "Macau SAR China"
      },
      {
        code: "+389",
        country: "Macedonia"
      },
      {
        code: "+261",
        country: "Madagascar"
      },
      {
        code: "+265",
        country: "Malawi"
      },
      {
        code: "+60",
        country: "Malaysia"
      },
      {
        code: "+960",
        country: "Maldives"
      },
      {
        code: "+223",
        country: "Mali"
      },
      {
        code: "+356",
        country: "Malta"
      },
      {
        code: "+692",
        country: "Marshall Islands"
      },
      {
        code: "+596",
        country: "Martinique"
      },
      {
        code: "+222",
        country: "Mauritania"
      },
      {
        code: "+230",
        country: "Mauritius"
      },
      {
        code: "+262",
        country: "Mayotte"
      },
      {
        code: "+52",
        country: "Mexico"
      },
      {
        code: "+691",
        country: "Micronesia"
      },
      {
        code: "+1 808",
        country: "Midway Island"
      },
      {
        code: "+373",
        country: "Moldova"
      },
      {
        code: "+377",
        country: "Monaco"
      },
      {
        code: "+976",
        country: "Mongolia"
      },
      {
        code: "+382",
        country: "Montenegro"
      },
      {
        code: "+1664",
        country: "Montserrat"
      },
      {
        code: "+212",
        country: "Morocco"
      },
      {
        code: "+95",
        country: "Myanmar"
      },
      {
        code: "+264",
        country: "Namibia"
      },
      {
        code: "+674",
        country: "Nauru"
      },
      {
        code: "+977",
        country: "Nepal"
      },
      {
        code: "+31",
        country: "Netherlands"
      },
      {
        code: "+599",
        country: "Netherlands Antilles"
      },
      {
        code: "+1 869",
        country: "Nevis"
      },
      {
        code: "+687",
        country: "New Caledonia"
      },
      {
        code: "+64",
        country: "New Zealand"
      },
      {
        code: "+505",
        country: "Nicaragua"
      },
      {
        code: "+227",
        country: "Niger"
      },
      {
        code: "+234",
        country: "Nigeria"
      },
      {
        code: "+683",
        country: "Niue"
      },
      {
        code: "+672",
        country: "Norfolk Island"
      },
      {
        code: "+850",
        country: "North Korea"
      },
      {
        code: "+1 670",
        country: "Northern Mariana Islands"
      },
      {
        code: "+47",
        country: "Norway"
      },
      {
        code: "+968",
        country: "Oman"
      },
      {
        code: "+92",
        country: "Pakistan"
      },
      {
        code: "+680",
        country: "Palau"
      },
      {
        code: "+970",
        country: "Palestinian Territory"
      },
      {
        code: "+507",
        country: "Panama"
      },
      {
        code: "+675",
        country: "Papua New Guinea"
      },
      {
        code: "+595",
        country: "Paraguay"
      },
      {
        code: "+51",
        country: "Peru"
      },
      {
        code: "+63",
        country: "Philippines"
      },
      {
        code: "+48",
        country: "Poland"
      },
      {
        code: "+351",
        country: "Portugal"
      },
      {
        code: "+1 787",
        country: "Puerto Rico"
      },
      {
        code: "+974",
        country: "Qatar"
      },
      {
        code: "+262",
        country: "Reunion"
      },
      {
        code: "+40",
        country: "Romania"
      },
      {
        code: "+7",
        country: "Russia"
      },
      {
        code: "+250",
        country: "Rwanda"
      },
      {
        code: "+685",
        country: "Samoa"
      },
      {
        code: "+378",
        country: "San Marino"
      },
      {
        code: "+966",
        country: "Saudi Arabia"
      },
      {
        code: "+221",
        country: "Senegal"
      },
      {
        code: "+381",
        country: "Serbia"
      },
      {
        code: "+248",
        country: "Seychelles"
      },
      {
        code: "+232",
        country: "Sierra Leone"
      },
      {
        code: "+65",
        country: "Singapore"
      },
      {
        code: "+421",
        country: "Slovakia"
      },
      {
        code: "+386",
        country: "Slovenia"
      },
      {
        code: "+677",
        country: "Solomon Islands"
      },
      {
        code: "+27",
        country: "South Africa"
      },
      {
        code: "+500",
        country: "South Georgia and the South Sandwich Islands"
      },
      {
        code: "+82",
        country: "South Korea"
      },
      {
        code: "+34",
        country: "Spain"
      },
      {
        code: "+94",
        country: "Sri Lanka"
      },
      {
        code: "+249",
        country: "Sudan"
      },
      {
        code: "+597",
        country: "Suriname"
      },
      {
        code: "+268",
        country: "Swaziland"
      },
      {
        code: "+46",
        country: "Sweden"
      },
      {
        code: "+41",
        country: "Switzerland"
      },
      {
        code: "+963",
        country: "Syria"
      },
      {
        code: "+886",
        country: "Taiwan"
      },
      {
        code: "+992",
        country: "Tajikistan"
      },
      {
        code: "+255",
        country: "Tanzania"
      },
      {
        code: "+66",
        country: "Thailand"
      },
      {
        code: "+670",
        country: "Timor Leste"
      },
      {
        code: "+228",
        country: "Togo"
      },
      {
        code: "+690",
        country: "Tokelau"
      },
      {
        code: "+676",
        country: "Tonga"
      },
      {
        code: "+1 868",
        country: "Trinidad and Tobago"
      },
      {
        code: "+216",
        country: "Tunisia"
      },
      {
        code: "+90",
        country: "Turkey"
      },
      {
        code: "+993",
        country: "Turkmenistan"
      },
      {
        code: "+1 649",
        country: "Turks and Caicos Islands"
      },
      {
        code: "+688",
        country: "Tuvalu"
      },
      {
        code: "+1 340",
        country: "U.S. Virgin Islands"
      },
      {
        code: "+256",
        country: "Uganda"
      },
      {
        code: "+380",
        country: "Ukraine"
      },
      {
        code: "+971",
        country: "United Arab Emirates"
      },
      {
        code: "+44",
        country: "United Kingdom"
      },
      {
        code: "+1",
        country: "United States"
      },
      {
        code: "+598",
        country: "Uruguay"
      },
      {
        code: "+998",
        country: "Uzbekistan"
      },
      {
        code: "+678",
        country: "Vanuatu"
      },
      {
        code: "+58",
        country: "Venezuela"
      },
      {
        code: "+84",
        country: "Vietnam"
      },
      {
        code: "+1 808",
        country: "Wake Island"
      },
      {
        code: "+681",
        country: "Wallis and Futuna"
      },
      {
        code: "+967",
        country: "Yemen"
      },
      {
        code: "+260",
        country: "Zambia"
      },
      {
        code: "+255",
        country: "Zanzibar"
      },
      {
        code: "+263",
        country: "Zimbabwe"
      }
    ],
    tab5: 'City',
    tab6: 'Number',
    tab7: 'Company',
    tab8: 'Position',
    tab9: 'Please specify your request (optional)',
    btn: 'Send'
  }
}
const ContactData = {
  fr: {
    title: 'Contact',
    address: '03, Boulevard des frere saouil Centre El Kheir 4eme etages B 408 07000 Biskra - Algerie',
    coords: [
      {
        title: 'Numéro de mobile',
        desc: '+213 5 55 55 68 48'
      },
      {
        title: 'Numéro de fix',
        desc: '+213 33 55 85 65'
      },
      {
        title: 'Email',
        desc: 'ops@abssafety.dz'
      },
    ],
    form: {
      tab1: 'Nom et prénom',
      tab2: 'Email',
      tab3: 'Numéro',
      tab4: 'Sujet',
      tab5: 'Message',
      btn: 'Envoyer'
    }
  },
  en: {
    title: 'Contact',
    address: '03, Str Saouli Brothers El Kheir Mall 4th floor B 408 07000 Biskra - Algeria',
    coords: [
      {
        title: 'Mobile number',
        desc: '+213 5 55 55 68 48'
      },
      {
        title: 'Telephone number',
        desc: '+213 33 55 85 65'
      },
      {
        title: 'Email',
        desc: 'ops@abssafety.dz'
      },
    ],
    form: {
      tab1: 'Name & Surname',
      tab2: 'Email',
      tab3: 'Number',
      tab4: 'Subject',
      tab5: 'Message',
      btn: 'Send'
    }
  }
}

const messageDelivery = {
  fr: {
    ss: "votre e-mail a été livré avec succès",
    fl: "nos excuses, une erreur s'est produite"
  },
  en: {
    ss: "your email was delivered successfully",
    fl: "our apologies, an error has occurred"
  }
}

export { NavData, brochureRequestData, MainData, QuoteData, ContactData, messageDelivery }


// WEBPACK FOOTER //
// ./src/wbstdt/Wbstdt.js